import React, { useEffect, useState } from 'react';
import { NavLink } from "react-router-dom";
import { getSubcategoryAll } from '../../Services/SubcategoryService';
import { useForm } from 'react-hook-form';
import { toastError } from "../../Components/Toasts/Toast";
import Swal from 'sweetalert2';
import { handlerFormError } from '../../Utils/Utils';
import { createSku, getSubcategoryPrefix, updateSku } from '../../Services/SkuService';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getCategoryAll } from '../../Services/CategoryService';
import { getSegmentAll } from '../../Services/SegmentService';
import Overlay from '../../Components/Overlay/Overlay';

let processingId = -1;

const SkuDetailPage = () => {
    const darkMode = useSelector(state => state.theme.darkMode);

    let { userInfo } = useSelector(state => state.auth);
    const { pageState, id, currentPrefix } = useParams();
    const navigate = useNavigate();

    const { register, handleSubmit, reset, control, formState: { errors } } = useForm({
        defaultValues: {
            id_segment: '',
            id_category: '',
            id_sub_category: '',
            prefix: ''
        }
    });

    const [state, setState] = useState({
        digits: [],
        segments: [],
        categories: [],
        subcategories: [],
        sku: {
            sku_index: 0,
            header_name: '',
            header_type: '',
            header_value: []
        },
        header_detail: {
            detail_code: '',
            detail_name: ''
        },
        header_detail_index: -1,
        activeDigit: 0,
        isViewOnly: false,
        firstPrefix: 'X',
        secondPrefix: 'X',
        processing: false
    });

    const onAddDigit = (digit) => {
        if (header_detail_index != -1) {
            toastError("Please finish your update first!");
        } else {
            const index = digits.findIndex(d => d.sku_index == digit);
            if (index == -1) {
                const _sku = {
                    sku_index: digit,
                    header_name: '',
                    header_type: '',
                    header_value: []
                };
                const _digits = [...digits, _sku];

                setState({ ...state, digits: _digits, activeDigit: digit, sku: _sku });
            } else {
                const _sku = digits.find(d => d.sku_index == digit);
                if (id && _sku.header_type == 'numeric' && _sku.header_value[0] == 0) {
                    _sku.header_value = [];
                }
                setState({ ...state, activeDigit: digit, sku: _sku });
            }
        }
    }

    const onSkuValChange = ({ target: { name, value } }) => {
        sku[name] = value;
        setState({ ...state, sku });
    }

    const isIndexSet = (index) => {
        return digits.findIndex(d => d.sku_index == index) > -1 ? 'page-link sku bg-orange text-bold' : 'page-link sku bg-black text-bold'
    }

    const getPrefix = (prefix) => {
        setState({
            ...state,
            firstPrefix: prefix.charAt(0) ? prefix.charAt(0) : 'X',
            secondPrefix: prefix.charAt(1) ? prefix.charAt(1) : 'X'
        });
    }

    const onAddHeaederDetailList = () => {

        if (!header_detail.detail_code || !header_detail.detail_name) {
            toastError('Please complete form before save/update data');
            return;
        }

        if (header_detail.detail_code.length > 1) {
            toastError('Code is only one character Ex: T');
            return;
        }

        const index = digits.findIndex(d => d.sku_index == activeDigit);
        if (header_detail_index < 0) {
            digits[index].header_value.push({
                detail_code: header_detail.detail_code,
                detail_name: header_detail.detail_name,
            });
        } else {
            digits[index].header_value[header_detail_index] = {
                detail_code: header_detail.detail_code,
                detail_name: header_detail.detail_name,
            };
        }

        setState({ ...state, digits });
        onResetHeaderDetail();
    }

    const onResetHeaderDetail = () => {
        setState({ ...state, header_detail: { detail_code: '', detail_name: '' }, header_detail_index: -1 });
    }

    const onAddHeaderDetailChange = ({ target: { name, value } }) => {
        header_detail[name] = value;
        setState({ ...state, header_detail });
    }

    const onEditHeaderDetail = (item, index) => {
        setState({ ...state, header_detail: JSON.parse(JSON.stringify(item)), header_detail_index: index })
    }

    const onRemoveHeaderDetail = (item, index) => {
        const i = digits.findIndex(d => d.sku_index == 3);
        digits[i].header_value.splice(index, 1);
        if (i == header_detail_index) {
            setState({ ...state, digits, header_detail: { detail_code: '', detail_name: '' } });
        } else {
            setState({ ...state, digits });
        }
    }

    const startProcessing = () => {
        processingId = setTimeout(() => {
            setState({ ...state, processing: true });
        }, 150);
    }

    const stopProcessing = () => {
        clearTimeout(processingId);
        setState({ ...state, processing: false });
    }

    const onReset = () => {
        setState({
            ...state,
            categories: [],
            subcategories: [],
            digits: [],
            sku: {
                sku_index: 0,
                header_name: '',
                header_type: '',
                header_value: []
            },
            header_detail: {
                detail_code: '',
                detail_name: ''
            },
            eader_detail_index: -1,
            activeDigit: 0,
            isViewOnly: false,
            firstPrefix: 'X',
            secondPrefix: 'X'
        });
        reset();
    }

    const onBack = () => { navigate(-1); }

    const onSubmit = (data) => {
        const postData = {
            id_sub_category: data.id_sub_category,
            prefix: data.prefix,
            sku_headers: digits
        }

        if (digits.length != 6) {
            Swal.fire({
                icon: 'error',
                title: 'Invalid digit format',
                text: 'You have to complete all digit value!'
            });
            return;
        }

        if (header_detail_index != -1) {
            toastError("Please finish your update first!");
            return;
        }

        let isValid = true;
        digits.forEach(d => {
            if (d.header_name == '' || d.header_type == '') {
                Swal.fire({
                    icon: 'error',
                    title: 'Form is not complete',
                    text: `Please complete form at digit number ${d.sku_index}!`
                });
                isValid = false;
                return;
            }
        });

        if (isValid) {
            startProcessing();
            const response = id ? updateSku(postData) : createSku(postData);
            response.then(res => {
                if (res.status == 200 || res.status == 201) {
                    Swal.fire({
                        icon: 'success',
                        title: id ? 'Update data success' : 'Save data success',
                        text: id ? 'Data has been updated!' : 'Data has been saved!'
                    }).then(r => onReset());

                    if (id) {
                        onBack();
                    }
                }
            }).catch(({ response: { data } }) => {
                handlerFormError(data);
            }).finally(_ => stopProcessing());
        }
    }

    const setChange = (e) => {
        if (e.target.name === 'id_segment') {
            getCategoryAll({ perpage: 100, filterAnd: `id_segment:${e.target.value}` }, ({ data }) => {
                setState({ ...state, categories: data.data, subcategories: [] });
            });
        } else if (e.target.name === 'id_category') {
            getSubcategoryAll({ perpage: 100, filterAnd: `id_category:${e.target.value}` }, ({ data }) => {
                setState({ ...state, subcategories: data.data });
            });
        }
    }

    useEffect(() => {
        switch (pageState) {
            case "add":
                getSegmentAll({ perpage: 100 }, ({ data }) => {
                    setState({ ...state, segments: data.data });
                });
                break;
            case "edit":
                getSubcategoryPrefix(id, currentPrefix).then(res => {
                    const reqSegments = getSegmentAll({ perpage: 1000 }).then(res => res.data.data);
                    const reqCategories = getCategoryAll({ perpage: 1000, filterAnd: `id_segment:${res.data.id_segment}` }).then(res => res.data.data);
                    const reqSubcategories = getSubcategoryAll({ perpage: 1000, filterAnd: `id_category:${res.data.id_category}` }).then(res => res.data.data);

                    Promise.all([reqSegments, reqCategories, reqSubcategories]).then(results => {
                        const [_segments, _categories, _subcategories] = results;

                        reset({
                            id_segment: res.data.id_segment,
                            id_category: res.data.id_category,
                            id_sub_category: res.data.id_sub_category,
                            prefix: currentPrefix
                        });

                        setState({
                            ...state,
                            segments: _segments,
                            categories: _categories,
                            subcategories: _subcategories,
                            digits: res.data.sku_headers,
                            firstPrefix: currentPrefix.charAt(0) ? currentPrefix.charAt(0) : 'X',
                            secondPrefix: currentPrefix.charAt(1) ? currentPrefix.charAt(1) : 'X'
                        });
                    });
                });
                break;
        }

    }, [pageState]);

    const { digits, sku, activeDigit, isViewOnly, header_detail, header_detail_index, firstPrefix, secondPrefix, processing } = state;

    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">{id ? 'Edit SKU Header' : 'Create SKU Header'} </h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><NavLink to="/home">Home</NavLink></li>
                                <li className="breadcrumb-item"><NavLink to="/sku">SKU Header</NavLink></li>
                                <li className="breadcrumb-item active">{id ? 'Edit SKU Header' : 'Create SKU Header'}</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className='col-md-12'>
                            <div className='card'>
                                <Overlay display={processing} />
                                <form name="form-sku" onSubmit={handleSubmit(onSubmit)}>
                                    <div className='card-header'>
                                        <div className='card-title'><i className='fa fa-edit' /> Form SKU</div>
                                    </div>
                                    <div className='card-body'>
                                        <div className='row'>
                                            <div className='col-md-4'>
                                                <div className='form-group'>
                                                    <label htmlFor="prefix">Product Segment</label>
                                                    <select name="id_segment" className='form-control' {...register("id_segment", { required: { value: true, message: 'Segment is required!' } })} onChange={setChange}>
                                                        <option value="">Select Segment</option>
                                                        {state.segments.map((v, i) => {
                                                            return <option value={v.id} key={i}>{v.segment_name}</option>
                                                        })}
                                                    </select>
                                                    {errors.id_segment && (<span className='text-danger' style={{ fontSize: 14 }}>{errors.id_segment.message}</span>)}
                                                </div>
                                                <div className='form-group'>
                                                    <label htmlFor="id_category">Product Category</label>
                                                    <select id='id_category' className='form-control' {...register("id_category", { required: { value: true, message: 'Category is required!' } })} onChange={setChange}>
                                                        <option value="">Select Category</option>
                                                        {state.categories.map((v, i) => {
                                                            return <option value={v.id} key={'ctg' + i}>{v.category_name}</option>
                                                        })}
                                                    </select>
                                                    {errors.id_category && (<span className='text-danger' style={{ fontSize: 14 }}>{errors.id_category.message}</span>)}
                                                </div>
                                                <div className='form-group'>
                                                    <label>Subcategory</label>
                                                    <select id='id_sub_category' className='form-control' {...register("id_sub_category", { required: { value: true, message: 'Subcategory is required!' } })}>
                                                        <option value={''}>Select Subcategory</option>
                                                        {
                                                            state.subcategories.map((item, i) => (<option key={`subctg-` + i} value={item.id}>{item.sub_category_name}</option>))
                                                        }
                                                    </select>
                                                    {errors.id_sub_category && (<span className='text-danger' style={{ fontSize: 14 }}>{errors.id_sub_category.message}</span>)}
                                                </div>

                                                <div className='form-group'>
                                                    <label htmlFor="prefix">Subcategory Prefix</label>
                                                    <input id="prefix" {...register("prefix", { required: { value: true, message: 'Subcategory prefix is required!' } })} readOnly={id ? true : false} placeholder='Subcategory prefix' className='form-control' onChange={(e) => getPrefix(e.target.value)} />
                                                    {errors.prefix && (<span className='text-danger' style={{ fontSize: 14 }}>{errors.prefix.message}</span>)}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="dropdown-divider" />

                                        <div className='row'>
                                            <div className='col-md-12' style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <h3>Active Digit {activeDigit > 0 ? activeDigit : '?'}</h3>
                                                <nav aria-label="Page navigation example">
                                                    <ul className="pagination">
                                                        <li className="page-item"><a className="page-link sku" style={darkMode ? { color: '#ccc' } : { color: 'black' }}>{firstPrefix ? firstPrefix : 'X'}</a></li>
                                                        <li className="page-item"><a className="page-link sku" style={darkMode ? { color: '#ccc' } : { color: 'black' }}>{secondPrefix ? secondPrefix : 'X'}</a></li>
                                                        <li className="page-item"><a className={isIndexSet(3)} style={{ cursor: 'pointer' }} onClick={() => onAddDigit(3)}>3</a></li>
                                                        <li className="page-item"><a className={isIndexSet(4)} style={{ cursor: 'pointer' }} onClick={() => onAddDigit(4)}>4</a></li>
                                                        <li className="page-item"><a className={isIndexSet(5)} style={{ cursor: 'pointer' }} onClick={() => onAddDigit(5)}>5</a></li>
                                                        <li className="page-item"><a className={isIndexSet(6)} style={{ cursor: 'pointer' }} onClick={() => onAddDigit(6)}>6</a></li>
                                                        <li className="page-item"><a className={isIndexSet(7)} style={{ cursor: 'pointer' }} onClick={() => onAddDigit(7)}>7</a></li>
                                                        <li className="page-item"><a className={isIndexSet(8)} style={{ cursor: 'pointer' }} onClick={() => onAddDigit(8)}>8</a></li>
                                                        <li className="page-item"><a className="page-link sku" style={darkMode ? { color: '#ccc' } : { color: 'black' }}>X</a></li>
                                                        <li className="page-item"><a className="page-link sku" style={darkMode ? { color: '#ccc' } : { color: 'black' }}>X</a></li>
                                                        <li className="page-item"><a className="page-link sku" style={darkMode ? { color: '#ccc' } : { color: 'black' }}>.</a></li>
                                                        <li className="page-item"><a className="page-link sku" style={darkMode ? { color: '#ccc' } : { color: 'black' }}>X</a></li>
                                                        <li className="page-item"><a className="page-link sku" style={darkMode ? { color: '#ccc' } : { color: 'black' }}>X</a></li>
                                                        <li className="page-item"><a className="page-link sku" style={darkMode ? { color: '#ccc' } : { color: 'black' }}>X</a></li>
                                                        <li className="page-item"><a className="page-link sku" style={darkMode ? { color: '#ccc' } : { color: 'black' }}>X</a></li>
                                                        <li className="page-item"><a className="page-link sku" style={darkMode ? { color: '#ccc' } : { color: 'black' }}>X</a></li>
                                                        <li className="page-item"><a className="page-link sku" style={darkMode ? { color: '#ccc' } : { color: 'black' }}>X</a></li>
                                                        <li className="page-item"><a className="page-link sku" style={darkMode ? { color: '#ccc' } : { color: 'black' }}>X</a></li>
                                                    </ul>
                                                </nav>
                                            </div>
                                        </div>

                                        <div className='row'>
                                            <div className='col-md-4'>
                                                <div className='form-group'>
                                                    <label htmlFor='header_name'>Header Name</label>
                                                    <input name='header_name' value={sku.header_name} className='form-control' rows={2} onChange={onSkuValChange} disabled={sku.sku_index == 0 || isViewOnly} />
                                                </div>

                                                <div className='form-group'>
                                                    <label>Header Type</label>
                                                    <select name='header_type' value={sku.header_type} className='form-control' rows={2} onChange={onSkuValChange} disabled={sku.sku_index == 0 || isViewOnly}>
                                                        <option value={''}>Select Header Type</option>
                                                        <option value="numeric">Numeric</option>
                                                        <option value="text">Free Text</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='card-footer'>
                                        <div className='row'>
                                            <div className='col-md-12'>
                                                <div className='d-flex' style={{ justifyContent: 'flex-end' }}>
                                                    <button type='button' className='btn btn-warning mr-3' style={{ width: 100 }} onClick={onBack}><i className='fa fa-reply' /> Back</button>
                                                    <button type='button' className='btn btn-danger mr-3' style={{ width: 100 }} onClick={onReset}><i className='fa fa-times' /> Clear</button>
                                                    <button type='submit' className='btn btn-dark' style={{ width: 100 }}
                                                        disabled={id ? !userInfo.access.sku_config.can_update : !userInfo.access.sku_config.can_create}>
                                                        <i className='fa fa-save' /> Save
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>

                            {sku.header_type == 'text' && <div className="row">
                                <div className='col-md-4'>
                                    <div className='card'>
                                        <div className='card-header'>
                                            <div className='card-title'><i className='fa fa-edit' /> {sku.header_name} Form</div>
                                        </div>
                                        <div className='card-body'>
                                            <div className='form-group'>
                                                <label htmlFor='detail_code'>Code</label>
                                                <input name='detail_code' value={header_detail.detail_code} className='form-control' rows={2} onChange={onAddHeaderDetailChange} disabled={sku.sku_index == 0 || isViewOnly} />
                                            </div>
                                            <div className='form-group'>
                                                <label htmlFor='detail_name'>Name</label>
                                                <input name='detail_name' value={header_detail.detail_name} className='form-control' rows={2} onChange={onAddHeaderDetailChange} disabled={sku.sku_index == 0 || isViewOnly} />
                                            </div>
                                            <div className='form-group'>
                                                <div style={{ display: 'flex', justifyContent: 'center', marginTop: 16 }}>
                                                    {header_detail_index < 0 &&
                                                        <div style={{ width: 150, marginRight: 10 }}><button type="button" className="btn btn-block btn-danger" onClick={onResetHeaderDetail}><i className='fa fa-times'></i>  Clear</button></div>
                                                    }
                                                    <div style={{ width: 150 }}><button type="button" className="btn btn-block btn-dark" onClick={onAddHeaederDetailList}><i className='fa fa-save'></i> {header_detail_index < 0 ? 'Save' : 'Update'}</button></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className='col-md-8'>
                                    <div className='card'>
                                        <div className='card-header'>
                                            <div className='card-title'><i className='fa fa-list' /> {sku.header_name} List</div>
                                        </div>
                                        <div className='card-body'>
                                            <table className='table'>
                                                <thead>
                                                    <tr>
                                                        <th>No</th>
                                                        <th>Code</th>
                                                        <th>Name</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {sku.header_value.map((item, index) => <tr key={index + 1}>
                                                        <td>{index + 1}</td>
                                                        <td>{item.detail_code}</td>
                                                        <td>{item.detail_name}</td>
                                                        <td style={{ width: '20%' }}>
                                                            <div>
                                                                <a onClick={() => onEditHeaderDetail(item, index)} style={{ cursor: 'pointer', color: 'green', display: 'inline-block', marginRight: 15 }}>
                                                                    <i className="fas fa-edit" />
                                                                    <span style={{ marginLeft: 10 }}>Edit</span>
                                                                </a>
                                                                <a onClick={() => onRemoveHeaderDetail(item, index)} style={{ cursor: 'pointer', color: 'maroon', display: 'inline-block' }}>
                                                                    <i className="fas fa-trash" />
                                                                    <span style={{ marginLeft: 10 }}>Remove</span>
                                                                </a>
                                                            </div>
                                                        </td>
                                                    </tr>)}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>}
                        </div>
                    </div>
                </div>
            </section >
        </div >
    )
}

export default SkuDetailPage;